module.exports = __webpack_public_path__ + "nav.png?c1614724343e0f5ad7affe45d9c43b4f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav.png
// module id = 52
// module chunks = 0